module.exports = __webpack_public_path__ + "static/media/automation-pause-icon.60f5bef3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/automation-pause-icon.svg
// module id = ./src/assets/images/automation-pause-icon.svg
// module chunks = 0